
import { axiosClient, axiosClientWithToken } from "./api.client";

const apiShow = {
    getAllShows: async() =>{
        try {
            const res = await axiosClient.get(`/show/all`);
            return res.data;
        } catch (error) {
            console.error('Error fetching shows:', error);
        }
    },

    getShowBySlug: async(slug) =>{
        try {
            const res = await axiosClient.get(`/show/accept/${slug}`);
            return res.data;
        } catch (error) {
            console.error('Error fetching shows:', error);
        }
    },

    getShowByTicketId: async(ticketId) =>{
        try {
            const res = await axiosClient.get(`/show/ticket/${ticketId}`);
            return res.data;
        } catch (error) {
            console.error('Error fetching shows:', error); 
        }
    },

    getShowDenyBySlug: async(slug) =>{
        try{
            const res = await axiosClient.get(`/show/deny/${slug}`);
            return res.data;
        } catch (error){
            console.error(error);
        }
    }
}
export default apiShow;